import WDHHearingTest from '../../../wdh-hearing-test';
// eslint-disable-next-line no-unused-vars
// import GTMTracking from '../../../wdh-hearing-test/src/js/utils/gtm-tracking';

var hearingTest = new WDHHearingTest();
hearingTest.run();